import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import { useLocation } from 'react-router-dom';
import useSWR from 'swr';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import Button from '../../../../common/base/Button';
import Container from '../../../../common/base/Container';
import Tabs from '../../../../common/base/Tabs';
import Text from '../../../../common/base/Text';
import { Div } from '../../../../common/helpers/StyledUtils';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { withTeamPermission } from '../../../../contexts/TeamPermissionContext';
import { StyledViewNavActions, StyledViewContent, StyledViewLayout, StyledViewNav, StyledViewNavHeader, StyledViewNavSecondary, ViewBreadcrumbsTitle } from '../../../../layouts/ViewLayout';
import NotFound from '../../NotFound';
import { ConnectionMetrics } from './ConnectionMetrics';
import { ConnectionOverview } from './ConnectionOverview';
import { ConnectionSettings } from './ConnectionSettings';
const ConnectionView = t0 => {
  const $ = _c(65);
  const {
    id: id_prop,
    mutate_connections
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    params: t1
  } = useRouteMatch();
  const {
    id: id_param
  } = t1;
  const id = id_prop || id_param;
  const location = useLocation();
  const {
    addToast
  } = useToasts();
  let t2;
  if ($[0] !== id) {
    t2 = APIMethodKeys.webhooks.get(id);
    $[0] = id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== HookdeckAPI.webhooks || $[3] !== id) {
    t3 = () => HookdeckAPI.webhooks.get(id);
    $[2] = HookdeckAPI.webhooks;
    $[3] = id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: connection,
    mutate: mutate_connection,
    error
  } = useSWR(t2, t3);
  let t4;
  if ($[5] !== mutate_connection || $[6] !== mutate_connections) {
    t4 = data => {
      mutate_connection(data);
      mutate_connections?.();
    };
    $[5] = mutate_connection;
    $[6] = mutate_connections;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const mutate = t4;
  const t5 = `/connections/${id}`;
  let t6;
  if ($[8] !== t5) {
    t6 = {
      label: "Overview",
      key: "overview",
      to: t5
    };
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `/connections/${id}/metrics`;
  let t8;
  if ($[10] !== t7) {
    t8 = {
      label: "Metrics",
      key: "metrics",
      to: t7
    };
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = `/connections/${id}/settings`;
  let t10;
  if ($[12] !== t9) {
    t10 = {
      label: "Settings",
      key: "settings",
      to: t9
    };
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t6 || $[16] !== t8) {
    t11 = {
      OVERVIEW: t6,
      METRICS: t8,
      SETTINGS: t10
    };
    $[14] = t10;
    $[15] = t6;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const TABS = t11 as const;
  let t12;
  if ($[18] !== HookdeckAPI.webhooks || $[19] !== addToast || $[20] !== id || $[21] !== mutate) {
    t12 = async () => {
      HookdeckAPI.webhooks.pause(id).then(connection_0 => {
        mutate(connection_0);
        addToast("success", "Connection paused");
      }).catch(() => {
        addToast("error", "Failed to pause connection");
      });
    };
    $[18] = HookdeckAPI.webhooks;
    $[19] = addToast;
    $[20] = id;
    $[21] = mutate;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const onPause = t12;
  let t13;
  if ($[23] !== HookdeckAPI.webhooks || $[24] !== addToast || $[25] !== id || $[26] !== mutate) {
    t13 = async () => {
      HookdeckAPI.webhooks.unpause(id).then(connection_1 => {
        mutate(connection_1);
        addToast("success", "Connection unpaused");
      }).catch(() => {
        addToast("error", "Failed to pause connection");
      });
    };
    $[23] = HookdeckAPI.webhooks;
    $[24] = addToast;
    $[25] = id;
    $[26] = mutate;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const onUnpause = t13;
  if (error && error.response?.status === 404) {
    let t14;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = {
        to: "/connections",
        text: "All Connections"
      };
      $[28] = t14;
    } else {
      t14 = $[28];
    }
    let t15;
    if ($[29] !== id) {
      t15 = <NotFound title="Connection not found" description="This connection does not exist or has been deleted." id={id} link={t14} />;
      $[29] = id;
      $[30] = t15;
    } else {
      t15 = $[30];
    }
    return t15;
  }
  if (error && error.response?.status === 410) {
    let t14;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = {
        justify: "center"
      };
      $[31] = t14;
    } else {
      t14 = $[31];
    }
    let t15;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <Text center={true} size="l">Connection deleted</Text>;
      $[32] = t15;
    } else {
      t15 = $[32];
    }
    let t16;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <Text as="p" m={{
        t: 4,
        b: 2
      }}>This connection was permanently deleted.</Text>;
      $[33] = t16;
    } else {
      t16 = $[33];
    }
    let t17;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <StyledViewLayout><StyledViewContent><Div flex={t14} p={8}><Container small={true} center={true}>{t15}{t16}<Button primary={true} ghost={true} m={{
                t: 4
              }} to="/connections">Connections</Button></Container></Div></StyledViewContent></StyledViewLayout>;
      $[34] = t17;
    } else {
      t17 = $[34];
    }
    return t17;
  }
  const t14 = connection?.name || connection?.full_name || id;
  let t15;
  if ($[35] !== t14) {
    t15 = {
      label: t14,
      highlight: true
    };
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  const title_breadcrumb = t15;
  let t16;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      label: "Connections",
      to: "/connections"
    };
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== title_breadcrumb) {
    t17 = [t16, title_breadcrumb];
    $[38] = title_breadcrumb;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  const breadcrumbs = t17;
  let t18;
  if ($[40] !== breadcrumbs) {
    t18 = <ViewBreadcrumbsTitle breadcrumbs={breadcrumbs} />;
    $[40] = breadcrumbs;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  const t19 = connection?.paused_at ? onUnpause : onPause;
  const t20 = connection?.paused_at ? "play_circle" : "pause_circle";
  const t21 = connection?.paused_at ? "Unpause" : "Pause";
  let t22;
  if ($[42] !== t19 || $[43] !== t20 || $[44] !== t21) {
    t22 = <StyledViewNavActions><Button.Permission role="member" outline={true} onClick={t19} icon={t20}>{t21} connection</Button.Permission></StyledViewNavActions>;
    $[42] = t19;
    $[43] = t20;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t18 || $[47] !== t22) {
    t23 = <StyledViewNavHeader>{t18}{t22}</StyledViewNavHeader>;
    $[46] = t18;
    $[47] = t22;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== location.pathname) {
    t24 = location.pathname.split("/")[3] || "overview";
    $[49] = location.pathname;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== TABS) {
    t25 = Object.values(TABS);
    $[51] = TABS;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t24 || $[54] !== t25) {
    t26 = <StyledViewNavSecondary><Tabs active_tab={t24} border={false} tabs={t25} /></StyledViewNavSecondary>;
    $[53] = t24;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t23 || $[57] !== t26) {
    t27 = <StyledViewNav>{t23}{t26}</StyledViewNav>;
    $[56] = t23;
    $[57] = t26;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== connection || $[60] !== mutate) {
    t28 = connection && <Switch><Route exact={true} path="/connections/:id" render={() => <ConnectionOverview connection={connection} />} /><Route path="/connections/:id/metrics" render={() => <ConnectionMetrics connection={connection} />} /><Route path="/connections/:id/settings" render={() => <ConnectionSettings connection={connection} mutate={mutate} />} /></Switch>;
    $[59] = connection;
    $[60] = mutate;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== t27 || $[63] !== t28) {
    t29 = <StyledViewLayout><StyledViewContent>{t27}{t28}</StyledViewContent></StyledViewLayout>;
    $[62] = t27;
    $[63] = t28;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  return t29;
};
export default withTeamPermission(ConnectionView, 'member');